export default __webpack_public_path__ + "static/media/AlegreyaSansSC-Bold.46e42da4.ttf";